import { useEffect, useState, type ChangeEvent } from "react";
import "./s62-photos.css";

const imageTypes = "image/jpeg,image/png,image/webp";
const roles = ["Étiquette", "Contre-étiquette"] as const;

/** Only this ordered list supplies previews, analysis and subsequent uploads. */
export function retainLabelPhotos(files: readonly File[]): File[] {
  return files.slice(0, 2);
}

export function labelPhotoPayload(files: readonly File[]): { front: File | null; back: File | null } {
  const retained = retainLabelPhotos(files);
  return { front: retained[0] ?? null, back: retained[1] ?? null };
}

function Preview({ file, index }: { file: File; index: number }) {
  const [url, setUrl] = useState("");
  useEffect(() => {
    const next = URL.createObjectURL(file);
    setUrl(next);
    return () => URL.revokeObjectURL(next);
  }, [file]);
  return <>{url && <img src={url} alt={`Photo ${index + 1} : ${roles[index]}`}/>}</>;
}

export function S62PhotoSelection({ files, onChange, disabled = false }: {
  files: readonly File[];
  onChange: (files: File[]) => void;
  disabled?: boolean;
}) {
  const [excluded, setExcluded] = useState(0);
  const selected = retainLabelPhotos(files);

  function select(event: ChangeEvent<HTMLInputElement>, replaceIndex?: number) {
    const incoming = Array.from(event.currentTarget.files ?? []);
    event.currentTarget.value = "";
    if (!incoming.length) return;
    if (replaceIndex !== undefined) {
      const next = [...selected];
      next[replaceIndex] = incoming[0];
      onChange(next);
    } else {
      setExcluded(Math.max(0, incoming.length - 2));
      onChange(retainLabelPhotos(incoming));
    }
  }

  return <fieldset className="s62-photo-selection" disabled={disabled}>
    <legend>Photos du vin</legend>
    <label className="s62-file-action">Choisir une ou deux photos
      <input type="file" accept={imageTypes} multiple onChange={select}/>
    </label>
    <p className="s62-photo-hint">Appareil photo ou galerie selon mon appareil. Photo 1 : étiquette ; photo 2 : contre-étiquette.</p>
    {excluded > 0 && <p role="status" className="s62-photo-exclusion">Seules les deux premières photos sont retenues et analysées. {excluded} photo{excluded > 1 ? "s" : ""} exclue{excluded > 1 ? "s" : ""}.</p>}
    <ol className="s62-photo-list">
      {selected.map((file, index) => <li key={index}>
        <Preview file={file} index={index}/>
        <div className="s62-photo-info">
          <strong>{index + 1} · {roles[index]}</strong>
          <span className="s62-photo-name">{file.name}</span>
          <label className="s62-file-action">Remplacer la photo {index + 1}
            <input type="file" accept={imageTypes} onChange={event => select(event, index)}/>
          </label>
          <button type="button" className="secondary" onClick={() => onChange(selected.filter((_, position) => position !== index))}>Retirer la photo {index + 1}</button>
        </div>
      </li>)}
    </ol>
    {selected.length === 1 && <label className="s62-file-action">Ajouter la contre-étiquette
      <input type="file" accept={imageTypes} onChange={event => select(event, 1)}/>
    </label>}
  </fieldset>;
}
